export const sliceSearchTitle = () => {

    const searchTitle = document.querySelectorAll('.search-results .wp-block-query-title');
    const searchTitleContainer = document.querySelectorAll('.search-results .search-result-title__container');

    if (searchTitle) {
        for (let i = 0; i < searchTitle.length; i++) {
            searchTitle[i].textContent = searchTitle[i].textContent.slice(19);

            for (let k = 0; k < searchTitleContainer.length; k++) {
                searchTitleContainer[k].classList.add('visible');
            }
        }
    }
}
